// Layout wrapper that adds top padding to clear the fixed navbar on inner pages.
export default function PageShell({ children, className = "" }) {
  return (
    <main className={`relative pt-20 min-h-[60vh] bg-white dark:bg-[#0B1120] text-[#0F172A] dark:text-white transition-colors ${className}`}>
      {children}
    </main>
  );
}
